import { forwardRef } from 'react';
import { Box } from '@alf/uikit';
import { HTMLSnippet } from '@namespace/snippets';

import styles from './index.module.css';

export const MarketDescriptionTooltip = forwardRef(
  ({ marketTemplateId }, ref) => (
    // div is required for proper positioning of absolute element
    <div ref={ref} className={styles.root}>
      <Box padding="m s" className={styles.tooltip}>
        <HTMLSnippet snippetId={`market_description_${marketTemplateId}`} />
      </Box>
    </div>
  )
);
